import { combineReducers, type PayloadAction, type Reducer, type UnknownAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

import auroraV2Reducer from "./features/auroraV2";
import batterySizerReducer from "./features/battery-sizer";
import deckReducer from "./features/deck";
import designToolReducer from "./features/design-tool";
import designPortalReducer from "./features/designPortal";
import dialogsReducer from "./features/dialogs";
import drawModeReducer from "./features/drawMode";
import notificationsReducer from "./features/notifications";
import proposalReducer from "./features/proposal";
import roofImageReducer from "./features/roofImage";
import soloReducer from "./features/solo";
import templateReducer from "./features/template";

const rootReducer = combineReducers({
  deck: deckReducer,
  designPortal: designPortalReducer,
  drawMode: drawModeReducer,
  roofImage: roofImageReducer,
  proposal: proposalReducer,
  template: templateReducer,
  dialogs: dialogsReducer,
  notifications: notificationsReducer,
  auroraV2: auroraV2Reducer,
  solo: soloReducer,
  designTool: designToolReducer,
  batterySizer: batterySizerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

function isHydrateAction(action: UnknownAction): action is PayloadAction<RootState> {
  return action.type === HYDRATE;
}

const reducerWithHydrate: Reducer<RootState, UnknownAction> = (state, action) => {
  if (isHydrateAction(action)) {
    return { ...state, ...action.payload };
  }

  return rootReducer(state, action);
};

export default reducerWithHydrate;
